// extracted by mini-css-extract-plugin
export default {"widthContainer":"style_widthContainer__2f49Z","primaryBtn":"style_primaryBtn__SPsBe","changeColor":"style_changeColor__qmITI"};